module.exports = __webpack_public_path__ + "25f4a7464ca9fe11f839731563b84b07.svg";